import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import '../../styles/RequestDemo.css';
import FirstSetp from './component/FirstSetp';
import SconedStep from './component/SconedStep';
import ThirdStep from './component/ThirdStep';
import { formatPhoneNumberDivision } from '../../utlites';
import { IoArrowBackOutline } from 'react-icons/io5';
import AnimatedStepIndicator from './component/Animatedstepindicator';
import { FcGoogle } from 'react-icons/fc';
import { supabase } from '../../api/supabase';
import { metadata } from 'framer-motion/client';

export default function RequestDemo() {
    const [currentStep, setCurrentStep] = useState(0);
    const [loading , setLoading] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    const [alertType, setAlertType] = useState('success');
    const [showAlert, setShowAlert] = useState(false);
    const [planId, setPlanId] = useState('');
    const [billingCycle, setBillingCycle] = useState('yearly');
    const [googleLoading, setGoogleLoading] = useState(false)
    const totalSteps = 3;


    const validationSchemas = Yup.object({
        contactName: Yup.string()
            .min(2, 'Name must be at least 2 characters')
            .required('Contact name is required'),
        email: Yup.string()
            .email('Invalid email address')
            .required('Email is required'),
        phone: Yup.string()
            .matches(/^[0-9+\-\s()]*$/, 'Invalid phone number')
            // .min(10, 'Phone number must be at least 10 digits')
            .required('Phone number is required'),
        hearAbout: Yup.string(),
        password: Yup.string()
            .required('Password is required')
            .min(8, 'Password must be at least 8 characters')
            .matches(/[a-z]/, 'Password must contain at least one lowercase letter')
            .matches(/[A-Z]/, 'Password must contain at least one uppercase letter')
            .matches(/\d/, 'Password must contain at least one number')
            .matches(
                /[@$!%*?&()[\]{}\-_=+;:'",.<>\/\\|`~]/,
                'Password must contain at least one special character'
            ),
        companyName: Yup.string().required('Company name is required'),
        companySize: Yup.string(),
        industry: Yup.string(),
        selectedPlan: Yup.string().required('Password is required'),
    });

    const initialValues = {
        contactName: '',
        email: '',
        phone: '',
        phoneCode: '+1',
        companyPhoneCode: "",
        hearAbout: '',
        companyName: '',
        companySize: '',
        companyPhone: '',
        industry: '',
        message: '',
        selectedPlan: '', // Add this
        billingCycle: 'yearly', // Add this 
    };

    const handleAlert = (message, type) => {
        setAlertMessage(message);
        setAlertType(type);
        setShowAlert(true);

        // Auto-hide success alerts after 5 seconds
        if (type === 'success') {
            setTimeout(() => {
                setShowAlert(false);
            }, 5000);
        }
    };

    const handleSubmit = async (data) => {
        console.log("loading is true and sumbit value");
        try {
            const API_URL = process.env.REACT_APP_BASE_URL;
            setLoading(true);
            console.log('Submitting to:', `${API_URL}/subscribe_company`);
            console.log('Data:', data);

            const response = await fetch(`${API_URL}/subscribe_company`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'appname': 'LimeTi',
                },
                body: JSON.stringify(data)
            });

            const result = await response.json();

            console.log('Response:', result);

            if (response.ok && result.success) {
                handleAlert(
                    'Subscription successful! You will be redirected to the login page shortly.',
                    'success'
                );

                // Optional: Redirect to success page after 2 seconds
                // Redirect to login page in a new tab after 2 seconds
                setTimeout(() => {
                    window.open(`${process.env.REACT_APP_DASHBOARD_URL}/login`, '_blank', 'noopener,noreferrer');
                }, 2000);

                // Reset form
                formik.resetForm();
                setCurrentStep(0);
            } else {
                handleAlert(result.message || 'Failed to create subscription. Please try again.', 'danger');
            }
        } catch (e) {
            console.error('Submission error:', e);
            handleAlert('An error occurred. Please check your connection and try again.', 'danger');
        } finally {
            setLoading(false);
        }
    };

    const handleNextClick = () => {
        const fieldsByStep = {
            0: ["selectedPlan"],
            1: ["companyName", "companySize", "industry"],
            2: ["contactName", "email", "phone", "password"],
        };

        const fieldsToValidate = fieldsByStep[currentStep];

        formik.validateForm().then((errors) => {
            // Filter errors down to only the current step's fields
            const stepErrors = Object.keys(errors)
                .filter((key) => fieldsToValidate.includes(key))
                .reduce((obj, key) => {
                    obj[key] = errors[key];
                    return obj;
                }, {});

            if (Object.keys(stepErrors).length === 0) {
                // No errors on this step — advance
                setCurrentStep((prev) => prev + 1);
            } else {
                // Touch only the current step's fields so errors show
                formik.setTouched(
                    fieldsToValidate.reduce((acc, field) => {
                        acc[field] = true;
                        return acc;
                    }, {})
                );
            }
        });
    };

    const formik = useFormik({
        initialValues,
        validationSchema: validationSchemas,
        onSubmit: async (values) => {
            const {countryCode:code , phone} = formatPhoneNumberDivision(values?.phoneCode, values?.phone,);
            // Handle form submission
            const objData={
                company:{
                    company_name: values?.companyName,
                    employee_count: values?.companySize,
                    industry: values?.industry,
                    overtime_rate_multiplier: 1.5,
                    over_time: "Daily",
                    minutes_before_clock_in_shift: "60",
                    business_phone_number: formatPhoneNumberDivision(values?.companyPhoneCode, values?.companyPhone)?.phone,
                    business_phone_code: formatPhoneNumberDivision(values?.companyPhoneCode, values?.companyPhone)?.countryCode,
                },
                user:{
                    full_name: values?.contactName,
                    first_name: values?.contactName.split(' ')[0],
                    last_name: values?.contactName.split(' ')[1],
                    email: values?.email,
                    phone_number: phone,
                    phone_number_code: code,
                    user_type: "Company Admin",
                    password: values?.password,
                },
                address:{},
                plan:{
                    id: planId || null,
                    billing_cycle: billingCycle || null
                }
            }
            await handleSubmit(objData)
        }
    });

    const handlePrev = () => {
        setCurrentStep((prev) => Math.max(prev - 1, 0));
    };

    const handleGoogleSignIn = async () => {
        try {
            setGoogleLoading(true);
            const {countryCode:code , phone} = formatPhoneNumberDivision(formik?.values?.phoneCode, formik?.values?.phone,);
            // STEP 1: Store form data in sessionStorage BEFORE redirect
            const currentFormData = {
                companyName: formik.values.companyName,
                companySize: formik.values.companySize,
                industry: formik.values.industry,
                companyPhone: formatPhoneNumberDivision(formik?.values?.companyPhoneCode, formik?.values?.companyPhone)?.phone,
                companyPhoneCode: formatPhoneNumberDivision(formik?.values?.companyPhoneCode, formik?.values?.companyPhone)?.countryCode,
                planId: planId,
                billingCycle: billingCycle,
                phoneNumber: phone,
                phoneNumberCode: code,
            };
            sessionStorage.setItem('pendingSubscription', JSON.stringify(currentFormData));

            // STEP 2: Redirect to Google OAuth
            const { data, error } = await supabase.auth.signInWithOAuth({
                provider: 'google',
                options: {
                    redirectTo: `${window.location.origin}/auth/callback`,
                    queryParams: {
                        access_type: 'offline',
                        prompt: 'consent',
                    }
                }
            });

            if (error) throw error;

            console.log('Google sign-in successful:', data);

        } catch (error) {
            console.error('Google sign-in error:', error);
            handleAlert('Failed to sign in with Google. Please try again.', 'danger');
        } finally {
            setGoogleLoading(false);
        }
    }


    return (
        <div 
            style={{
                display: 'flex',
                justifyContent: currentStep === 2 ? 'flex-start' :'center',
                alignItems: 'center',
                width: "100%",
                background: "#fff",
                flexDirection: "column",
            }}
        >

            {/* Show the alert */}
            {showAlert && (
                <div
                    className={`alert alert-${alertType} alert-dismissible fade show mt-2`}
                    role="alert"
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: '50%',
                        right: 0,
                        zIndex: 9999,
                        margin: '0',   
                        padding: '1rem', 
                        transform: 'translateX(-50%)',
                        width: '80%',
                        maxWidth: '600px',
                    }}
                >
                    {alertMessage}
                    <button type="button" className="btn-close" onClick={() => setShowAlert(false)}></button>
                </div>
            )}

            <div className="request-demo-card" style={{maxWidth: currentStep !== 0 ? "600px" : "100%"}}>
                <div className="demo-header" style={{width: "100%",flexDirection: "row" , gap: "16px",justifyContent: "center"}}>
                    <h2 className="demo-title-demo">
                        {
                            currentStep === 0 ? 
                                "Select Your plan"
                            :
                                currentStep === 1 ? 
                                    "Company Details Help us understand your business and needs"
                                :
                                    "Please Enter Your Personal Information"
                        }
                    </h2>
                </div>

                {/* Animated Progress Steps */}
                <AnimatedStepIndicator />

                {/* Progress Steps */}
                <div className="progress-steps mb-4" data-progress={currentStep}>
                    {[0, 1, 2].map((step) => (
                        <div key={step} className="step-wrapper">
                            <div className={`step-circle ${currentStep >= step ? 'active' : ''} ${currentStep > step ? 'completed' : ''}`}>
                                {currentStep > step ? '✓' : ''}
                            </div>
                            {step < 2 && <div className={`step-line ${currentStep > step ? 'active' : ''}`} />}
                        </div>
                    ))}
                </div>

                {/* Form */}
                <form onSubmit={formik.handleSubmit}>

                    {/* Step 1 */}
                    {currentStep === 0 && (
                        <ThirdStep
                            formik={formik}
                            setPlanId={setPlanId}
                            setBillingCycleText={setBillingCycle}
                            submitLoading={loading}
                            nextStep={setCurrentStep}
                        />
                        
                    )}

                    {/* Step 2 */}
                    {currentStep === 1 && (
                        <SconedStep formik={formik}/>
                    )}

                    {/* Step 3 */}
                    {currentStep === 2 && (
                        <FirstSetp formik={formik}/>
                    )}

                    {/* Navigation Buttons */}
                    {currentStep !== 0 && (
                        <div style={{display:"flex" , flexDirection: "column" , gap: "1rem"}}>

                            {/* Google Sign-In Button */}
                            {
                                currentStep === 2 && (
                                    <button
                                        type="button"
                                        onClick={handleGoogleSignIn}
                                        disabled={googleLoading}
                                        className="btn w-100"
                                        style={{
                                            border: '1px solid #dadce0',
                                            borderRadius: '20px',
                                            padding: '12px 20px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            gap: '10px',
                                            backgroundColor: '#EFF0F6',
                                            fontSize: '14px',
                                            fontWeight: '500',
                                            color: '#3c4043',
                                            cursor: googleLoading ? 'not-allowed' : 'pointer',
                                            transition: 'all 0.2s',
                                        }}
                                    >
                                        {googleLoading ? (
                                            <div className="spinner-border spinner-border-sm" role="status">
                                                <span className="sr-only"></span>
                                            </div>
                                        ) : (
                                            <>
                                                <FcGoogle size={25} />
                                                <span>Continue with Google</span>
                                            </>
                                        )}
                                    </button>
                                )
                            }

                            {/* Next And Perv */}
                            <div
                                style={{
                                    width: '100%',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    // marginTop: '20px',
                                    gap: "1rem"
                                }}
                            >
                                {currentStep > 0 && (
                                    <button type="button" onClick={handlePrev} style={styles.btnPervious}>
                                        Previous
                                    </button>
                                )}
                                <button
                                    disabled={loading}
                                    type="button"
                                    onClick={() => {
                                        if (currentStep < totalSteps - 1) {
                                            handleNextClick();   // validate & advance
                                        } else {
                                            formik.handleSubmit(); // final submit on last step
                                        }
                                    }}
                                    style={styles.btnSubmit}
                                >
                                    {loading ? (
                                        <div style={{ display: "flex", justifyContent: "center" }}>
                                            <div className="spinner-border" role="status">
                                                <span className="sr-only"></span>
                                            </div>
                                        </div>
                                    ) : currentStep < totalSteps - 1 ? 'Next' : 'Submit'}
                                </button>
                            </div>

                        </div>
                    )}


                </form>
            </div>
        </div>
    );
}


const styles = {
    btnSubmit: {
        width: 'fit-content',
        display: "flex",
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        backgroundColor: "#7bb321",
        padding: "10px 20px",
        border: 'none',
        borderRadius: "20px"
    },
    btnPervious: {
        width: 'fit-content',
        display: "flex",
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        backgroundColor: "#e7eee7",
        padding: "10px 20px",
        border: 'none',
        borderRadius: "20px"
    }
}